export const SET_INITIAL_DEVICE_LIST = 'SET_INITIAL_DEVICE_LIST';
export const SET_CURRENT_DEVICE_LIST = 'SET_CURRENT_DEVICE_LIST';
export const DELETE_DEVICE_FROM_REDUX = 'DELETE_DEVICE_FROM_REDUX';
export const SET_NUMBER_OF_DEVICES = 'SET_NUMBER_OF_DEVICES';
export const SET_NEW_ADDED_DEVICES_LIST = 'SET_NEW_ADDED_DEVICES_LIST';
export const SET_DEVICE_ERROR_CODE = 'SET_DEVICE_ERROR_CODE';
export const DELETE_DEVICE_FROM_NEW_ADDED_DEVICES = 'DELETE_DEVICE_FROM_NEW_ADDED_DEVICES';
export const CLEAR_NEW_ADDED_DEVICES_LIST = 'CLEAR_NEW_ADDED_DEVICES_LIST';
export const SET_DEVICE_INFO_TO_CONTACT_PAGE = 'SET_DEVICE_INFO_TO_CONTACT_PAGE';
